export default "__VITE_ASSET__KcyH528r__"